import { Post } from '@/ts/graphqlschema'

export const DEFAULT_AUTHOR: any = {
  id: '0111',
  name: 'Ba Hoa',
  description: '',
  first_name: 'Ba Hoa',
  last_name: '',
  avatar: {
    filename_disk: '/fallback.svg',
  },
  title: 'Tên tác giả',
}

export const DEFAULT_PAGE_DATA: any = {
  template: 'default',
}

export const DEFAULT_POST: Post = {
  id: '0000',
  title: 'Đây là bài viết mẫu',
  post_type_string: 'post',
  description:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  status: 'published',
  content: '',
  publish_date: '2021-10-14T15:02:59',
  slug: '/',
  keywords: [],
  author: DEFAULT_AUTHOR,
}

export const AUTHOR_ID = [
  {
    id: '0831139a-4b67-4b32-984e-ea41a1d643a4',
  },
  {
    id: '0a2657e2-0918-4857-b97c-0c48bda9d137',
  },
  {
    id: '12156b03-b70b-4308-8aa3-396cbbe7b140',
  },
  {
    id: '3360fa6c-7216-4a6d-97f6-e2ca1506d4ca',
  },
  {
    id: '41ef3843-35e2-41e2-a651-22cd26bbf8ab',
  },
  {
    id: '47b0fe00-7d9e-4104-8e4f-b7db6657cad3',
  },
  {
    id: '562255fd-3a14-493d-a46e-6a58d5372bb9',
  },
  {
    id: '6bc5d820-173e-4d9e-862c-e50110950369',
  },
  {
    id: '7e19318e-63a1-49bf-a59d-968b7f36eba2',
  },
  {
    id: '83d250ae-d8e8-4909-a39d-d766cf504a82',
  },
  {
    id: 'a1c81dbe-89e9-4b48-a828-04bcadb5fcb6',
  },
  {
    id: 'a39d1126-c47e-44da-bc62-874331920fb3',
  },
]
